import { useFootnotes } from './FootnoteProvider'

export function Footnotes() {
  const [Notes] = useFootnotes()

  return (
    <footer className="bg-white">
      <div className="font-light bg-navy/10 text-black-60">
        <div className="container flex-col justify-start max-w-screen-lg mx-auto">
          <dl className="grid grid-cols-[auto_1fr] items-start gap-y-1 gap-x-2 px-5 py-8 text-xs">{Notes}</dl>
        </div>
      </div>
    </footer>
  )
}
